module.exports = __webpack_public_path__ + "media/images/matchmaking-banner-5e87e4180897c0101a7ed7858ed85172.jpg";